import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { baseURL } from "../../components/BaseURL";
import LineChart from "./LineChart";

export default function ChartDetails() {
  const [chartData, setChartData] = React.useState({});
  const { id } = useParams();
  const [adData, setAdData] = useState([]);
  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const [HubzoneOwned, setHubzoneOwned] = useState("");
  const [WomanOwned, setWomanOwned] = useState("");
  const [
    SociallyAndEconomicallyDisadvantaged,
    setSociallyAndEconomicallyDisadvantaged,
  ] = useState("");
  const [NumberEmployees, setNumberEmployees] = useState("");
  const [CompanyWebsite, setCompanyWebsite] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");

  React.useEffect(() => {
    if (adData.description) {
      // description = Company : Technical research Associates, Inc.\nAward Title : THE DEVELOPMENT OF A SMALL-SCALE WATERFALL PAINT STRIPPING SYSTEM\n
      if (adData.description.includes("Company :")) {
        let companyName = adData.description
          .split("Company : ")[1]
          .split("\n")[0];
        // all the word of the name will start with capital letter
        companyName = companyName.replace(/\w\S*/g, function (txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
        setName(companyName);
      }
      let fulladdress = "";
      if (adData.description.includes("Address1 :")) {
        const address = adData.description
          .split("Address1 : ")[1]
          .split("\n")[0];
        fulladdress += address;
      }

      if (adData.description.includes("City :")) {
        const city = adData.description.split("City : ")[1].split("\n")[0];
        fulladdress += ", " + city;
      }

      if (adData.description.includes("State :")) {
        const state = adData.description.split("State : ")[1].split("\n")[0];
        fulladdress += ", " + state;
      }

      if (adData.description.includes("Zip :")) {
        const zip = adData.description.split("Zip : ")[1].split("\n")[0];
        fulladdress += ", " + zip;
      }
      setAddress(fulladdress);

      if (adData.description.includes("Hubzone Owned :")) {
        const HubzoneOwned = adData.description
          .split("Hubzone Owned : ")[1]
          .split("\n")[0];
        setHubzoneOwned(HubzoneOwned);
      }

      if (adData.description.includes("Woman Owned :")) {
        const WomanOwned = adData.description
          .split("Woman Owned : ")[1]
          .split("\n")[0];
        setWomanOwned(WomanOwned);
      }

      if (
        adData.description.includes("Socially and Economically Disadvantaged :")
      ) {
        const SociallyAndEconomicallyDisadvantaged = adData.description
          .split("Socially and Economically Disadvantaged : ")[1]
          .split("\n")[0];
        setSociallyAndEconomicallyDisadvantaged(
          SociallyAndEconomicallyDisadvantaged
        );
      }

      if (adData.description.includes("Company Website :")) {
        const CompanyWebsite = adData.description
          .split("Company Website : ")[1]
          .split("\n")[0];
        setCompanyWebsite(CompanyWebsite);
      }

      if (
        adData.description.includes("email") ||
        adData.description.includes("Email") ||
        adData.description.includes("PI Email") ||
        adData.description.includes("Awardee email")
      ) {
        if (adData.description.includes("email")) {
          setEmail(adData.description.split("email : ")[1].split("\n")[0]);
        } else if (adData.description.includes("Email")) {
          setEmail(adData.description.split("Email : ")[1].split("\n")[0]);
        } else if (adData.description.includes("Awardee email")) {
          setEmail(
            adData.description.split("Awardee email : ")[1].split("\n")[0]
          );
        } else {
          setEmail(adData.description.split("PI Email : ")[1].split("\n")[0]);
        }
      }

      if (adData.description.includes("Awardee Contact")) {
        setPhone(
          adData.description.split("Awardee Contact : ")[1].split("\n")[0]
        );
      }
    }
  }, [adData]);

  useEffect(() => {
    if (id) {
      fetch(`${baseURL}/project-main/get-single-ad/${id}`)
        .then((res) => res.json())
        .then((data) => {
          setAdData(data);
        })
        .catch((err) => console.log(err));
    }
  }, [id]);

  React.useEffect(() => {
    if (id) {
      fetch(`${baseURL}/project-main/get-chart-info/${id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status === "success") {
            setChartData(data);
          } else {
            console.log("No chart data");
          }
        })
        .catch((err) => console.log(err));
    }
  }, [id]);

  const [byProgramAndPhase, setByProgramAndPhase] = useState({});
  const [byYear, setByYear] = useState({});
  const [byAgency, setByAgency] = useState({});

  React.useEffect(() => {
    const data = chartData;
    const sampleDataStructure = {
      labels: [],
      datasets: [
        {
          type: "bar",
          label: "Award Count",
          data: [],
        },
        {
          type: "line",
          label: "Award Amount",
          data: [],
        },
      ],
    };
    if (data?.data?.byProgramAndPhase?.labels) {
      let byProgramAndPhase = JSON.parse(JSON.stringify(sampleDataStructure));
      byProgramAndPhase.labels = data.data.byProgramAndPhase.labels;
      byProgramAndPhase.datasets[0].data =
        data.data.byProgramAndPhase.count.map((item) => item);
      byProgramAndPhase.datasets[1].data =
        data.data.byProgramAndPhase.amount.map((item) => item);
      setByProgramAndPhase(byProgramAndPhase);
    }

    if (data?.data?.byYear?.labels) {
      let byYear = JSON.parse(JSON.stringify(sampleDataStructure));
      byYear.labels = data.data.byYear.labels;
      byYear.datasets[0].data = data.data.byYear.count;
      byYear.datasets[1].data = data.data.byYear.amount;
      setByYear(byYear);
    }

    if (data?.data?.byAgency?.labels) {
      let byAgency = JSON.parse(JSON.stringify(sampleDataStructure));
      byAgency.labels = data.data.byAgency.labels;
      byAgency.datasets[0].data = data.data.byAgency.count;
      byAgency.datasets[1].data = data.data.byAgency.amount;
      setByAgency(byAgency);
    }
  }, [chartData]);

  return (
    <div className="bg-[#0e0c23]">
      <div className="min-h-screen px-3 md:w-5/6 lg:w-3/4 mx-auto mb-20 py-8">
        <h2 className="text-2xl font-bold text-pink-500">{name}</h2>
        <div className="p-3">
          <h4 className="text-lg font-bold  border-b-2 border-pink-500 text-white">
            Company Information
          </h4>
          {/* flex large screen */}
          <div className="flex flex-col lg:flex-row">
            <div className="w-full lg:w-1/3 pr-3">
              <h6 className="font-bold text-white">Address</h6>
              <div className="text-white">{address}</div>
              <div>
                <p className="text-white">Email: {email}</p>
              </div>
              <div>{phone ? <p>Phone: {phone}</p> : null}</div>
            </div>
            {/*<div className="w-full lg:w-1/3 pr-3">*/}
            {/*<h6 className='font-bold'>Information</h6>*/}
            {/*    <div>*/}
            {/*        <div className='text-bold'>Number of Employees: {NumberEmployees}</div>*/}
            {/*    </div>*/}
            {/*</div>*/}
            {/*<div className="w-full lg:w-1/3">*/}
            {/*<h6 className='font-bold'>Ownership information</h6>*/}
            {/*    <div>*/}
            {/*        <div className='text-bold'>HUBZone Owned: {HubzoneOwned}</div>*/}
            {/*        <div className='text-bold'>Socially and Economically Disadvantaged: {SociallyAndEconomicallyDisadvantaged}</div>*/}
            {/*        <div className='text-bold'>Woman Owned: {WomanOwned}</div>*/}
            {/*    </div>*/}
            {/*</div>*/}
          </div>

          {CompanyWebsite && (
            <div className="mt-8 flex items-center">
              {/* website icon */}
              <img
                className="mr-2"
                style={{ width: "30px", height: "30px" }}
                alt="Website"
                src="data:image/png;base64,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"
              />
              <div className="font-bold ">{CompanyWebsite}</div>
            </div>
          )}

          {chartData ? (
            <div className="border my-8">
              <div className="bg-gray-800 text-xl text-white p-3">
                Award Chart
              </div>
              {/* flex large and medium screen */}
              <div className="p-3 flex flex-col xl:flex-row py-5">
                <div className="mx-2 mb-8">
                  <h3 className="mb-3">
                    <span className="bg-gray-800 rounded text-white px-3 py-1">
                      By Program and Phase
                    </span>
                  </h3>
                  {byProgramAndPhase.labels && (
                    <LineChart data={byProgramAndPhase} />
                  )}
                </div>
                <div className="mx-2 mb-8">
                  <h3 className="mb-3">
                    <span className="bg-gray-800 rounded text-white px-3 py-1">
                      By Year
                    </span>
                  </h3>
                  {byYear.labels && <LineChart data={byYear} />}
                </div>
                <div className="mx-2 mb-5">
                  <h3 className="mb-3">
                    <span className="bg-gray-800 rounded text-white px-3 py-1">
                      By Agency
                    </span>
                  </h3>
                  {byAgency.labels && <LineChart data={byAgency} />}
                </div>
              </div>
            </div>
          ) : null}

          <div className="border mt-8">
            <div className="bg-gray-800 text-xl text-white p-3">
              Award Listing
            </div>
            {/* flex large and medium screen */}
            {chartData?.company_ads?.map((item, index) => {
              let amount,
                program,
                phase,
                agency,
                award_year,
                abstract = "";
              if (item.description.includes("Award Amount : ")) {
                amount = item.description
                  .split("Award Amount : ")[1]
                  .split("\n")[0];
              } else amount = "";
              if (item.description.includes("Program : ")) {
                program = item.description
                  .split("Program : ")[1]
                  .split("\n")[0];
              } else program = "";
              if (item.description.includes("Phase : ")) {
                phase = item.description.split("Phase : ")[1].split("\n")[0];
              } else phase = "";
              if (item.description.includes("Agency : ")) {
                agency = item.description.split("Agency : ")[1].split("\n")[0];
              } else agency = "";
              if (item.description.includes("Award Year : ")) {
                award_year = item.description
                  .split("Award Year : ")[1]
                  .split("\n")[0];
              } else award_year = "";
              if (item.description.includes("Abstract : ")) {
                abstract = item.description.split("Abstract : ")[1]; //.split('"')[0]
              } else abstract = "";

              return (
                <div key={index} className="m-3 mb-5 pb-3 border-b">
                  <h4 className=" text-lg font-bold text-pink-500">
                    {program} {phase}: {item.title}
                  </h4>
                  <p className="text-sm text-white opacity-80">Amount: {amount}</p>
                  <div className="px-3 text-sm text-white opacity-80">{abstract}</div>

                  <div className="flex flex-wrap mt-1">
                    {program && (
                      <div className="px-2 m-1 text-white rounded text-sm bg-gray-700">
                        {program}
                      </div>
                    )}
                    {phase && (
                      <div className="px-2 m-1 text-white rounded text-sm bg-gray-700">
                        {phase}
                      </div>
                    )}
                    {agency && (
                      <div className="px-2 m-1 text-white rounded text-sm bg-gray-700">
                        {agency}
                      </div>
                    )}
                    {award_year && (
                      <div className="px-2 m-1 text-white rounded text-sm bg-gray-700">
                        {award_year}
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
